import PropTypes from 'prop-types';

export const QuestionInGroupType = PropTypes.shape({
  id: PropTypes.number,
  text: PropTypes.string,
  status: PropTypes.string,
  orderInGroup: PropTypes.number,
});

export const QuestionGroupType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  merchantProduct: PropTypes.number,
  questions: PropTypes.arrayOf(QuestionInGroupType),
});

export const AnswerType = PropTypes.shape({
  id: PropTypes.number,
  question: PropTypes.number,
  text: PropTypes.string,
  isPreferred: PropTypes.bool,
  createdBy: PropTypes.number,
});

export const QuestionType = PropTypes.shape({
  id: PropTypes.number,
  merchantProduct: PropTypes.number,
  order: PropTypes.number,
  text: PropTypes.string,
  status: PropTypes.string,
  mainAnswer: PropTypes.shape(AnswerType),
  answers: PropTypes.arrayOf(AnswerType),
  groups: PropTypes.arrayOf(QuestionGroupType),
});
